import { User } from "@/models/User"

import { Notification } from "./Notification"

export interface CalendarNotificationEvent {
  id: string
  type: "TIME_OFF"
  description: string
  startDate: string
  endDate: string
  allDay: boolean
  users: User[]
}

interface CalendarNotificationContent {
  event?: CalendarNotificationEvent
  oldEvent?: CalendarNotificationEvent
  initiator?: User
  datesChanged?: boolean
  descriptionChanged?: boolean
  assigneesChanged?: boolean
}

/** Normalizes calendar notification payloads so notification components consume typed users and events. */
export class NotificationCalendar extends Notification {
  get content(): CalendarNotificationContent {
    return super.content as CalendarNotificationContent
  }

  get event(): CalendarNotificationEvent | undefined {
    return this.toCalendarEvent(this.content.event)
  }

  get oldEvent(): CalendarNotificationEvent | undefined {
    return this.toCalendarEvent(this.content.oldEvent)
  }

  get initiator(): User {
    return new User(this.content.initiator)
  }

  private toCalendarEvent(
    event?: CalendarNotificationEvent
  ): CalendarNotificationEvent | undefined {
    if (!event) return undefined

    return {
      ...event,
      users: (event.users ?? []).map(user => new User(user))
    }
  }
}
